const dtfCache = new Map<string, Intl.DateTimeFormat>()
const lfCache = new Map<string, Intl.ListFormat>()
const prCache = new Map<string, Intl.PluralRules>()

export function getDtf(
	id: string,
	tz: string,
	kind: 'date' | 'time' | 'datetime',
	fmt: 'short' | 'long' | 'full',
): Intl.DateTimeFormat {
	const key = `${id}:${tz}:${kind}:${fmt}`
	let dtf = dtfCache.get(key)
	if (dtf) return dtf
	dtf = new Intl.DateTimeFormat(id, {
		...(kind === 'date'
			? { dateStyle: fmt }
			: kind === 'time'
				? { timeStyle: fmt }
				: { dateStyle: fmt, timeStyle: fmt }),
		timeZone: tz,
	})
	dtfCache.set(key, dtf)
	return dtf
}

export function getLf(
	id: string,
	kind: 'and' | 'or' | 'list',
	fmt: 'short' | 'long',
): Intl.ListFormat {
	const key = `${id}:${kind}:${fmt}`
	let lf = lfCache.get(key)
	if (lf) return lf
	lf = new Intl.ListFormat(id, {
		style: fmt,
		// eslint-disable-next-line security/detect-object-injection
		type: (
			{ and: 'conjunction', or: 'disjunction', list: 'unit' } as const
		)[kind],
	})
	lfCache.set(key, lf)
	return lf
}

export function getPr(id: string, kind: 'card' | 'ord'): Intl.PluralRules {
	const key = `${id}:${kind}`
	let pr = prCache.get(key)
	if (pr) return pr
	pr = new Intl.PluralRules(id, {
		type: kind === 'card' ? 'cardinal' : 'ordinal',
	})
	prCache.set(key, pr)
	return pr
}
